import React from 'react'

const Spinner = ({ extraCss }) => {
  return (
    <div css={[sSpinner, extraCss]}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

export default Spinner

const sSpinner = {
  display: 'inline-block',
  position: 'relative',
  width: '80px',
  height: '80px',
  top: 0,
  left: 0,
  zIndex: 1011,
  transform: 'scale(2.5)',

  div: {
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    zIndex: 1011,
    width: '64px',
    height: '64px',
    margin: '8px',
    border: `8px solid currentColor`,
    borderRadius: '50%',
    animation: 'rotate360 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
    borderColor: `currentColor transparent transparent transparent`,
  },
  'div:nth-child(1)': { animationDelay: '-0.45s' },
  'div:nth-child(2)': { animationDelay: '-0.3s' },
  'div:nth-child(3)': { animationDelay: '-0.15s' },
}
